// const BaseApi = "https://new.lgbtjobs.com.au/job-board-script/api"
// const BaseApi = "https://lgbtijobs.logicspice.com/job-board-script/api"
const BaseApi = "https://api.lgbtijobs.com.au/api";

export default BaseApi;
